exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.state-banner[data-v-9e514672] {\n  margin-bottom: .8rem;\n  text-align: center;\n}\n.state-banner .md-icon[data-v-9e514672] {\n    position: relative;\n    bottom: .05rem;\n    margin-right: .2rem;\n}\n.state-banner--pending .state-banner__message[data-v-9e514672],\n  .state-banner--pending .md-icon[data-v-9e514672] {\n    color: #31858B;\n}\n.state-banner--approved .state-banner__message[data-v-9e514672],\n  .state-banner--approved .md-icon[data-v-9e514672] {\n    color: #578AD6;\n}\n.state-banner--rejected .state-banner__message[data-v-9e514672],\n  .state-banner--rejected .md-icon[data-v-9e514672] {\n    color: #2C3030;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9e514672","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/verification/make/Verification.StateBanner.vue
// module id = rt0A
// module chunks = 1